import inputData from './inputData/presentation-feedback-survey';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'presentation-feedback-survey',
  title: 'Presentation Feedback Survey',
  description: 'Learn how your presentation landed by gathering honest input from your audience.',
  image: '/images/templates/presentation-feedback-survey.png',
  tags: ['get-feedback', 'human-resources'],
  inputData: inputData,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

